// extracted by mini-css-extract-plugin
export var copyableField = "_sd-4";
export var customerBadge = "_sd-0";
export var customerInfoTitle = "_sd-2";
export var details = "_sd-1";
export var dropdownContainer = "_sd-5";
export var dropdownImage = "_sd-6";
export var editAssigneeForm = "_sd-a";
export var editButton = "_sd-3";
export var email = "_sd-7";
export var hidden = "_sd-d";
export var input = "_sd-8";
export var saveButton = "_sd-b";
export var shopifyIcon = "_sd-c";
export var suggestionBadge = "_sd-e";
export var suggestionText = "_sd-f";
export var username = "_sd-9";